export const ICON_CLASS = "pnr-feedback--icon";
export const MESSAGES_CLASS = "pnr-feedback--messages";
export const DISMISS_BUTTON_CLASS = "pnr-feedback--dismiss--button";